
export interface State {
  "id": number,
  "name": string,
  "isActive": boolean,
}
